///<reference path="../../../../../../node_modules/@angular/router/src/router.d.ts"/>
import {Component, EventEmitter, HostListener, Inject, OnInit, Output} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {AlertService, EventManager, JhiLanguageService} from 'ng-jhipster';
import {Candidature} from './candidature.model';
import {CandidatureService} from './candidature.service';
import {Commission, CommissionService} from '../commission';
import {ExportService, JhiAlertComponent, Principal, User, UserService} from '../../shared';
import {Departement, GrhumService, Pays} from '../grhum';
import {Request, Response} from '@angular/http';
import {CONSTANTS} from '../../cadens.constants';
import {Cursus} from './cursus.model';
import {Cours} from './cours.model';
import {CursusService} from './cursus.service';
import {CoursService} from './cours.service';
import {CandidatureFormation} from './candidature-formation.model';
import {CandidatureFormationService} from './candidature-formation.service';
import {Adresse} from './adresse/adresse.model';
import {AdresseService} from './adresse/adresse.service';
import {Concours} from './concours.model';
import {ConcoursService} from './concours.service';
import {Observable, Subject, Subscription} from 'rxjs';
import {ReponseService} from './formation/reponse.service';
import {CasParticulierEI, FormationService, Question} from '../formation';
import {PageScrollInstance, PageScrollService} from 'ng2-page-scroll';
import {DOCUMENT} from '@angular/platform-browser';
import {Referent, ReferentService} from '../referent';
import {ConfirmationService} from 'primeng/components/common/api';
import {TranslateService} from 'ng2-translate';
import {EntityVerification} from './entity-verification.model';
import {PreavisService} from './preavis/preavis.service';
import {Preavis} from './preavis/preavis.model';


@Component({
    selector: 'jhi-candidature-detail',
    templateUrl: './candidature-detail.component.html'
})
export class CandidatureDetailComponent implements OnInit {

    @Output() listeCoursChange: EventEmitter<Cours[]> = new EventEmitter();

    currentAccount: any; // User connecté
    candidature: Candidature;
    listeCandidatures: String[];
    page: number;
    adresse: Adresse; // Adresse d'une candidature
    candidatureFormation: CandidatureFormation;
    otherCandidatures: CandidatureFormation[];
    courses: Cursus[]; // Liste des cursus universitaires post bac
    listeCours: Cours[] = []; // Liste des cours de la candidature
    concours: Concours[]; // Liste des concours dans scolarité
    questions: Question[] = []; // Liste des questions complémentaires
    referents: Referent[] = []; // Liste des referents pour form de recommandations
    public navIsFixed = true;
    paysListe: Pays[];
    deptListe: Departement[];
    missingPieces = true;
    constants = CONSTANTS;
    routeData: any;
    currentPage: string; // page de candidature affichée
    eventSubscriber: Subscription;
    currentLang: string;
    isSaving = false;
    public isUser = false;
    public isEditable = false;
    public avisEnabled = 0;
    public traitementEnabled = 0;
    public dateLimiteAvis: number;
    private subscription: any;
    private candidatureUser: User = null;
    private commissionOuvertePourCandidature: Commission = null;
    private isCurrentAccountNotUser: boolean = false;
    private commissionCouranteCandidature: Commission = null;
    private commissionFermePourCandidature: Commission = null;
    private adresseLoaded;
    private desCategoriesFormationDisponibles: boolean = false;
    private preavisVisuAllEnabled: boolean;
    private preavisModifEnabled: boolean;
    private eventsSubject: Subject<void> = new Subject<void>();
    private readonly commentaireObligatoireAlerteId = 3615436;
    private readonly alertCommentaireObligatoireTimeout = 120000;


    constructor(private jhiLanguageService: JhiLanguageService,
                private candidatureService: CandidatureService,
                private adresseService: AdresseService,
                private reponseService: ReponseService,
                private activatedRoute: ActivatedRoute,
                private candidatureFormationService: CandidatureFormationService,
                private exportService: ExportService,
                private cursusService: CursusService,
                private coursService: CoursService,
                private concoursService: ConcoursService,
                private referentService: ReferentService,
                private route: ActivatedRoute,
                private router: Router,
                private principal: Principal,
                private alertService: AlertService,
                private grhumService: GrhumService,
                private eventManager: EventManager,
                private pageScrollService: PageScrollService,
                private confirmationService: ConfirmationService,
                private translateService: TranslateService,
                private userService: UserService,
                private CommissionService: CommissionService,
                private preavisService: PreavisService,
                private formationService: FormationService,
                @Inject(DOCUMENT) private document: any) {
        // Fichiers json de langue à charger pour cette page
        this.jhiLanguageService.setLocations(['candidature', 'global', 'cursus', 'formation', 'referent']);
        this.currentLang = '' + this.jhiLanguageService.currentLang;
        this.routeData = this.activatedRoute.data.subscribe(data => {
            this.page = data['pagingParams'].page;
            let listeActionGroupee = data['pagingParams'].listeCandidatures;
            if (listeActionGroupee != null) {
                this.listeCandidatures = listeActionGroupee.split(',');
            }
        });
    }

    /**
     * Charger la liste des pays, départements au chargement de la page
     */
    ngOnInit() {
        this.isSaving = true;
        this.grhumService.queryPays().subscribe(
            (res: Response) => {
                this.paysListe = res.json();
            }, (res: Response) => {
                this.isSaving = false;
                this.onError(res);
            });
        this.grhumService.queryDepartement().subscribe(
            (res: Response) => {
                this.deptListe = res.json();
            }, (res: Response) => {
                this.isSaving = false;
                this.onError(res);
            });
        this.subscription = this.route.params.subscribe(params => {
            let userId = params['userId'];
            this.principal.identity().then((account) => {
                this.currentAccount = account;
                if (!Principal.isAuthorityInListe('ROLE_USER', this.currentAccount.authorities)) {
                    this.isCurrentAccountNotUser = true;
                }
                if (userId != null) {
                    this.userService.findById(userId).subscribe(user => {
                        this.candidatureUser = user;
                        this.load(params['id']);
                    });
                } else {
                    this.candidatureUser = account;
                    this.load(params['id']);
                }
            });
            this.registerChangeInCandidatures();
        });
    }

    registerChangeInCandidatures() {
        this.eventSubscriber = this.eventManager.subscribe('candidatureListModification', () =>
            this.load(this.candidatureFormation.id));
    }

    load(idCandidatureFormation) {
        this.isSaving = true;
        if (idCandidatureFormation < 1) {
            // Chargement d'une candidature pour création, init les valeurs par défaut
            this.isEditable = true;
            this.isUser = true;
            this.initNewCandidature(this.candidatureUser);
            this.adresse = new Adresse();
            this.adresseLoaded = true;
        } else {
            if (Principal.isAuthorityInListe('ROLE_USER', this.candidatureUser.authorities)) {
                this.isUser = true;
            }
            // Chargement d'une candidature existante en base
            let recalculateEi: boolean = true;
            if (this.isEditable == false) {
                recalculateEi = false;
            }
            this.candidatureFormationService.
            find(idCandidatureFormation, recalculateEi).subscribe(candidatureFormation => {
                this.candidatureFormation = candidatureFormation;
                this.currentPage = this.candidatureFormation.pageEdition;

                if (candidatureFormation != null && candidatureFormation.candidatureId != null) {
                    let loads: any[] = [];
                    loads.push(this.candidatureService.find(candidatureFormation.candidatureId));
                    loads.push(this.adresseService.find(this.candidatureFormation.candidatureId));
                    loads.push(this.coursService.query({'candidatureFormationId': this.candidatureFormation.id}));

                    if (!this.isUser) {
                        loads.push(this.preavisService.query({'candidatureFormationId': this.candidatureFormation.id}));
                    }
                    if (this.candidatureFormation.commissionId != null) {
                        loads.push(this.CommissionService.find(this.candidatureFormation.commissionId));
                    }
                    if (this.candidatureFormation.formationId != null) {
                        loads.push(this.formationService.findPourEtudiant(this.candidatureFormation.formationId, this.candidatureFormation.userId));
                    }
                    Observable.forkJoin(loads).subscribe((results: any[]) => {
                            let index = 0;
                            if (results.length > 0) {
                                this.candidature = results[index];
                                index++;

                                //adresse
                                this.adresse = results[index];
                                index++;
                                this.adresseLoaded = true;

                                //cours
                                this.listeCours = results[index].json();
                                this.listeCoursChange.emit(this.listeCours);
                                index++;

                                //preavis
                                this.candidatureFormation.listePreavis = [];
                                let listePreavis: Preavis[] = null;
                                if (!this.isUser) {
                                    listePreavis = results[index].json();
                                    index++;
                                }

                                //commission
                                if (this.candidatureFormation.commissionId != null) {
                                    let commission: Commission = results[index];
                                    index++;
                                    if (commission != null) {
                                        this.dateLimiteAvis = commission.dateLimiteAvis;
                                        this.commissionCouranteCandidature = commission;
                                    }
                                }

                                //formation
                                if (this.candidatureFormation.formationId != null) {
                                    this.candidatureFormation.formation = results[index];
                                    //index++;
                                }
                                this.gestionDroits(this.candidatureUser.id, this.dateLimiteAvis, this.candidatureUser.authorities);
                                if (this.candidatureFormation.formation != null &&
                                    this.candidatureFormation.formation.lecteurs != null &&
                                    this.candidatureFormation.formation.avecPreavis
                                ) {
                                    if (!this.isUser) {
                                        //calcul liste preavis
                                        this.candidatureFormation.listePreavis = Preavis.buildListePreavis(
                                            this.currentAccount.id,
                                            this.preavisVisuAllEnabled,
                                            this.preavisModifEnabled,
                                            this.candidatureFormation.id,
                                            listePreavis,
                                            this.candidatureFormation.formation.lecteurs,
                                            this.candidatureFormation.formation.users);
                                    }
                                }
                                this.isSaving = false;
                            }
                        },
                        (res: Response) => {
                            this.isSaving = false;
                            this.onError(res);
                        });
                }
            }, (res: Response) => {
                this.isSaving = false;
                this.onError(res);
            });
            if (this.isCurrentAccountNotUser) {
                this.candidatureFormationService.findCommissionPourCandidature(true, idCandidatureFormation).subscribe((commission: Commission[]) => {
                    if (commission != null && commission.length > 0) {
                        this.commissionOuvertePourCandidature = commission[0];
                    }
                }, (res: Response) => {
                    this.isSaving = false;
                    this.onError(res);
                });
                this.candidatureFormationService.findCommissionPourCandidature(false, idCandidatureFormation).subscribe((commission: Commission[]) => {
                    if (commission != null && commission.length > 0) {
                        this.commissionFermePourCandidature = commission[0];
                    }
                }, (res: Response) => {
                    this.isSaving = false;
                    this.onError(res);
                });
            }
        }
    }


    initNewCandidature(account) {
        this.candidature = {
            'id': null,
            'civilite': account.civilite,
            'prenom': account.firstName,
            'nomPatronymique': account.lastName,
            'prenom2': account.otherNames,
            'nomUsuel': account.lastNameUsage,
            'dateNaissance': account.birthDate != null ? new Date(account.birthDate) : null,
            'userId': account.id
        };
        this.candidatureFormation = {
            'id': null,
            'pageEdition': CONSTANTS.CIVILITE,
            'statut': CONSTANTS.CREATED,
            'userId': account.id,
            'reinscription': false,
            'fc': false,
            'email': account.email
        };
        if (account.etudiant != null && account.etudiant.numeroEtudiant != null) {
            this.candidatureFormation.reinscription = true;
        }
        this.candidatureService.query({userId: account.id}).subscribe(
            (res: Response) => {
                let candis = res.json();
                if (candis != null && candis.length > 0) {
                    this.candidature = CandidatureService.copyCandidature(this.candidature, candis[0]);
                }
                this.currentPage = this.candidatureFormation.pageEdition;
                this.isSaving = false;
            }, (res: Response) => {
                this.isSaving = false;
                this.onError(res);
            });
    }

/**SAVE du 03/02/2026**/
    save(fullValidation: boolean, forceTransmit: boolean, callbackSaveOk: () => any): void {
        this.isSaving = true;
        if (this.isEditable && !(this.candidatureFormation.pageEdition === CONSTANTS.FORMATION && this.desCategoriesFormationDisponibles == false)) {
            // Enregistrement fait par le candidat
            if (this.candidatureFormation.pageEdition === CONSTANTS.CIVILITE) {
                // Save the CIVILITE page: Créer la candidature ou la mettre à jour
                if (this.candidature.civilite == null) {
                    this.onErrorMessage({message: 'cadensApp.candidature.messages.validate.civilite'});
                } else if (!this.candidature.id) {
                    this.createCandidature(fullValidation, callbackSaveOk);
                } else {
                    if (this.listeCours != null && this.listeCours.length > 0) {
                        this.listeCours.forEach(cours => cours.candidatureFormationId = this.candidatureFormation.id);
                        this.coursService.update(this.listeCours).subscribe(listCours => {
                            this.listeCours = listCours;
                        });
                    }
                    this.updateCandidature(fullValidation, forceTransmit, false, callbackSaveOk);
                }
            } else if (this.candidatureFormation.pageEdition === CONSTANTS.SCOLARITE) {
                // Save the SCOLARITE page: update les Cursus, Concours, et la Candidature

                let validCursuses = CursusService.areCursusesValid(this.courses, this.candidatureFormation.reinscription);
                let validConcours = this.concoursService.areConcoursValid(this.concours);
                if (fullValidation && (this.courses == null || this.courses.length < 1)) {
                    this.onErrorMessage({message: 'cadensApp.candidature.messages.error.cursusobligatoire'});
                } else if (fullValidation && !this.candidatureFormation.reinscription && this.candidature.bourse === null) {
                    this.onErrorMessage({message: 'cadensApp.candidature.messages.error.bourseobligatoire'});
                } else if (fullValidation && !this.candidatureFormation.reinscription && this.candidature.bourse && this.candidature.echelon ===null) {
                        this.onErrorMessage({message: 'cadensApp.candidature.messages.error.echelonBourseObligatoire'});
                } else if (fullValidation && !this.candidatureFormation.reinscription && this.candidature.bac == null) {
                    this.onErrorMessage({message: 'cadensApp.candidature.messages.error.bacobligatoire'});
                } else if (fullValidation && !this.candidatureFormation.reinscription && this.candidature.bacAnnee == null) {
                    this.onErrorMessage({message: 'cadensApp.candidature.messages.error.bacanneeobligatoire'});
                } else if (fullValidation && !this.candidatureFormation.reinscription && Candidature.areSpecialitesBacObligatoires(this.candidature)
                    && (this.candidature.bacSpec1LibelleCourt == null || this.candidature.bacSpec2LibelleCourt == null)) {
                    this.onErrorMessage({message: 'cadensApp.candidature.messages.error.bacspecialitesobligatoire'});
                } else if (fullValidation && !this.candidatureFormation.reinscription && Candidature.areSpecialitesBacObligatoires(this.candidature)
                    && (this.candidature.bacSpec1LibelleCourt === this.candidature.bacSpec2LibelleCourt)) {
                    this.onErrorMessage({message: 'cadensApp.candidature.messages.error.bacspecialitesdifferentes'});
                } else if (fullValidation && !this.candidatureFormation.reinscription && this.candidature.bacEtab == null
                    && this.candidature.bacEtablissementAutre == null) {
                    this.onErrorMessage({message: 'cadensApp.candidature.messages.error.etablissementobligatoire'});
                } else if (fullValidation && !this.candidatureFormation.reinscription && this.candidature.bacPays === '100'
                    && this.candidature.bacEtab == null) {
                    this.onErrorMessage({message: 'cadensApp.candidature.messages.error.etablissementobligatoire'});
                } else if (fullValidation && (this.concours.find(con => con.passage == null) != null)) {
                    this.onErrorMessage({message: 'cadensApp.candidature.messages.error.concoursobligatoire'});
                } else if (fullValidation && validCursuses != null) {
                    this.onErrorMessage({message: 'cadensApp.candidature.messages.error.cursus.' + validCursuses});
                } else if (fullValidation && validConcours != null) {
                    this.onErrorMessage({message: 'cadensApp.candidature.messages.error.concours.' + validConcours});
                } else {
                    if(!this.candidature.bacAnnee || this.candidature.bacAnnee < 2021) {
                        this.candidature.bacSpec1LibelleCourt = null;
                        this.candidature.bacSpec2LibelleCourt = null;
                    }
                    let updates = [this.concoursService.update(this.concours),
                        this.candidatureService.update(this.candidature)];
                    if (this.courses != null && this.courses.length > 0) {
                        updates.push(this.cursusService.update(this.courses));
                    }
                    Observable.forkJoin(updates).subscribe((results: any[]) => {
                            if (results.length > 0) {
                                this.concours = results[0];
                            }
                            if (results.length > 2) {
                                this.courses = results[2]._body;
                            }
                            //Modification Eric : pour gérer le flag EI il faut sauver la candidature meme en sauvegarde temporaire
                            if (fullValidation) {
                                this.updateCandidatureFormation(CONSTANTS.FORMATION, CONSTANTS.SCOLARITE, forceTransmit, fullValidation);
                            } else {
                                this.updateCandidatureFormation(CONSTANTS.SCOLARITE, CONSTANTS.SCOLARITE, forceTransmit, fullValidation);
                            }
                            this.isSaving = false;
                        },
                        (res: Response) => {
                            this.isSaving = false;
                            this.onError(res);
                        });
                }
            } else if (this.candidatureFormation.pageEdition === CONSTANTS.FORMATION) {
                // Save the FORMATION page: update les Réponses et la CandidatureFormation
                let message = this.valideFormation(fullValidation);
                if (message != null && message.messageText != null) {
                    this.onErrorMessage(message.messageText, message.messageParam);
                } else {
                    let page = CONSTANTS.FORMATION;
                    if (fullValidation) {
                        page = this.candidatureFormation.reinscription ? CONSTANTS.CONFIRMATION : CONSTANTS.PIECES;
                        // tslint:disable-next-line:max-line-length
                    }  /*else if (fullValidation && this.candidatureFormation.ei === 2 && this.candidatureFormation.indicBourseExcellence === null) {
                        this.onErrorMessage({message: 'cadensApp.formation.master.indicBourseObligatoire'});
                    }*/
                    let updateReponses = this.reponseService.update(this.questions);
                    if (updateReponses != null) {
                        Observable.forkJoin([updateReponses]).subscribe(results => {
                            this.questions = results[0];
                            this.updateCandidatureFormation(page, CONSTANTS.FORMATION, forceTransmit, fullValidation);
                        }, (res: Response) => {
                            this.isSaving = false;
                            this.onError(res);
                        });
                    } else {
                        this.updateCandidatureFormation(page, CONSTANTS.FORMATION, forceTransmit, fullValidation);
                    }
                }
            } else if (this.candidatureFormation.pageEdition === CONSTANTS.PIECES) {
                // Save the PIECES page: juste besoin de confirmer si tout est ok
                let page = CONSTANTS.PIECES;
                if (fullValidation && this.missingPieces) {
                    return this.onErrorMessage({message: 'cadensApp.candidature.messages.error.piecesobligatoire'});
                }
                let countOfReferentNotExchange: number = this.referents.filter(referent => referent.typeReferent != CONSTANTS.CONTACT_PEDAGO && referent.typeReferent != CONSTANTS.CONTACT_ADMIN).length;
                if (fullValidation && this.referents.length > 0 && countOfReferentNotExchange > 0) {
                    this.referents.forEach(ref => ref.key == null ? ref.key = 'true' : true);
                }
                let updateRefs = [];
                this.referents.forEach(ref => updateRefs.push(this.referentService.update(ref, null)));
                if (updateRefs.length > 0) {
                    Observable.forkJoin(updateRefs).subscribe(() => {
                        if (fullValidation) {
                            page = CONSTANTS.CONFIRMATION;
                        }
                        this.updateCandidatureFormation(page, CONSTANTS.PIECES, forceTransmit, fullValidation);
                    }, (res: Response) => {
                        this.eventsSubject.next();
                        this.isSaving = false;
                        this.onError(res);
                    });
                } else {
                    if (fullValidation) {
                        page = CONSTANTS.CONFIRMATION;
                    }
                    this.updateCandidatureFormation(page, CONSTANTS.PIECES, forceTransmit, fullValidation);
                }
            }
        } else {
            // Quand le candidat est en lecture seule
            if (this.currentPage === CONSTANTS.CIVILITE) {
                this.goToStep(CONSTANTS.SCOLARITE);
            } else if (this.currentPage === CONSTANTS.SCOLARITE) {
                this.goToStep(CONSTANTS.FORMATION);
            } else if (this.currentPage === CONSTANTS.FORMATION) {
                this.goToStep(CONSTANTS.PIECES);
            }
            this.isSaving = false;
        }
    }

    goToHome(): any {
        this.isSaving = false;
        if (this.isCurrentAccountNotUser == false) {
            this.router.navigate(['/espaceCandidat']);
        } else {
            this.router.navigate(['/candidature']);
        }
    }

    /**
     * Enregistrer une candidature sans valider tous les champs obligatoire
     * Redirection vers mon espace candidat ensuite
     */
    saveForLaterAndGoHome() {
        this.saveForLater();
        this.goToHome();
    }

    /**
     * Enregistrer une candidature sans valider tous les champs obligatoire
     * Redirection vers mon espace candidat ensuite
     */
    saveForLater() {
        this.save(false, false, this.goToHome);
    }

    backToListe(direct ?: boolean) {
        if (direct && this.listeCandidatures != null && this.listeCandidatures.length > 1) {
            if (this.listeCandidatures[this.listeCandidatures.length - 1] !== '' + this.candidatureFormation.id) {
                this.nextCandidature();
            } else {
                this.previousCandidature();
            }
        } else {
            if (this.candidatureFormation != null) {
                this.router.navigate(['/candidature-back/' + this.candidatureFormation.id]);
            } else {
                this.router.navigate(['/candidature']);
            }
        }
        this.isSaving = false;
    }

    previousCandidature() {
        // Go to the previous Candidature in Action groupées
        let previous = this.listeCandidatures.indexOf(String(this.candidatureFormation.id));
        this.router.navigate(['/candidature/' + this.listeCandidatures[previous - 1], {
            listeCandidatures: this.listeCandidatures
        }]);
        this.load(this.listeCandidatures[previous - 1]);
        let pageScrollInstance: PageScrollInstance = PageScrollInstance.simpleInstance(this.document, '#TOP');
        this.pageScrollService.start(pageScrollInstance);
    }

    nextCandidature() {
        // Go to the next Candidature in Action groupées
        let next = this.listeCandidatures.indexOf('' + this.candidatureFormation.id);
        this.router.navigate(['/candidature/' + this.listeCandidatures[next + 1], {
            listeCandidatures: this.listeCandidatures
        }]);
        this.load(this.listeCandidatures[next + 1]);
        let pageScrollInstance: PageScrollInstance = PageScrollInstance.simpleInstance(this.document, '#TOP');
        this.pageScrollService.start(pageScrollInstance);
    }

    /**
     * To create a new Candidature -> Post it to CandidatureFormation
     */


    createCandidature(fullValidation: Boolean, callbackSaveOk: () => any) {
        if (this.adresse && this.candidatureFormation && this.candidature) {
            if (navigator && navigator.userAgent) {
                this.candidature.navigator = navigator.userAgent;
            }
            let stream = this.candidatureService.create(this.candidature);
            stream.subscribe(candi => {
                if (fullValidation) {
                    this.candidatureFormation.pageEdition = CONSTANTS.SCOLARITE;
                }
                this.candidature = candi;
                this.candidatureFormation.candidatureId = candi.id;
                this.adresse.candidatureId = candi.id;

                let adresseStream = this.adresseService.update(this.adresse);
                let candFormStream = this.candidatureFormationService.create(this.candidatureFormation);
                Observable.forkJoin([candFormStream, adresseStream]).subscribe(results => {
                    this.candidatureFormation = results[0];
                    this.isSaving = false;
                    let nextUrl = '/candidature/' + this.candidatureFormation.id;
                    if (this.candidatureUser.id != this.currentAccount.id) {
                        nextUrl = nextUrl + '/' + this.candidatureUser.id;
                    }
                    this.router.navigate([nextUrl]);
                    this.load(this.candidatureFormation.id);
                }, (res: Response) => {
                    this.candidatureFormation.pageEdition = CONSTANTS.CIVILITE;
                    this.onError(res);
                });
            }, (res: Response) => {
                this.candidatureFormation.pageEdition = CONSTANTS.CIVILITE;
                this.onError(res);
            });
        }
    }

    updateCandidature(fullValidation: Boolean, forceTransmit: Boolean, verifier: Boolean, callbackSaveOk: (n: number) => any) {
        if (fullValidation) {
            this.candidatureFormation.pageEdition = CONSTANTS.SCOLARITE;
        }
        let candStream = this.candidatureService.update(this.candidature);
        let adresseStream = this.adresseService.update(this.adresse);
        Observable.forkJoin([candStream, adresseStream]).subscribe(results => {
            this.candidature = results[0];
            this.adresse = results[1];
            //on a besoin d'avoir fini de sauver la candidature avant de sauver la candidature formation
            let candFormStream = this.candidatureFormationService.update(this.candidatureFormation, forceTransmit, fullValidation);

            Observable.forkJoin([candFormStream]).subscribe(results => {
                let oldCandidatureFormation = this.candidatureFormation;
                this.candidatureFormation = results[0];
                if (this.isEditable && this.traitementEnabled > 0) {
                    if (verifier) {
                        this.load(this.candidatureFormation.id);
                        this.verifierCandidature();
                    } else {
                        this.backToListe(true);
                    }
                } else {
                    this.goToStep(this.candidatureFormation.pageEdition);
                }
            }, (res: Response) => {
                this.isSaving = false;
                this.onError(res);
            });
            /*
                        if (this.listeCours != null && this.listeCours.length > 0) {
                            this.listeCours.forEach(cours => cours.candidatureFormationId = this.candidatureFormation.id);
                            this.coursService.update(this.listeCours).subscribe(listCours => {
                                this.listeCours = listCours;
                            });
                        }
            */
        }, (res: Response) => {
            this.isSaving = false;
            this.onError(res);
        });
    }

    updateCandidatureFormation(page, oldPage, forceTransmit: boolean, fullValidation: Boolean) {
        this.candidatureFormation.pageEdition = page;
        this.candidatureFormationService.update(this.candidatureFormation, forceTransmit, fullValidation).subscribe(candiFormation => {
            this.candidatureFormation = candiFormation;
            this.isSaving = false;
            this.goToStep(this.candidatureFormation.pageEdition);
        }, (res: Response) => {
            this.candidatureFormation.pageEdition = oldPage;
            this.isSaving = false;
            this.onError(res);
        });
        if (this.listeCours != null && this.listeCours.length > 0) {
            this.listeCours.forEach(cours => cours.candidatureFormationId = this.candidatureFormation.id);
            this.coursService.update(this.listeCours).subscribe(listCours => {
                this.listeCours = listCours;
            });
        }
    }

    saveParGestionnaire(verifier: boolean) {
        // Si pas de motif pour avis défavorable, on ne peut pas sauvegarder
        if(this.candidatureFormation !== undefined && this.candidatureFormation !== null
            && this.candidatureFormation.avis === this.constants.NOTFAVORABLE
        && (this.candidatureFormation.commentaire === undefined  || this.candidatureFormation.commentaire === null)) {
            this.alertService.closeAlert(this.commentaireObligatoireAlerteId);
            this.alertService.addAlert({id: this.commentaireObligatoireAlerteId, type: 'danger',
                msg: 'cadensApp.candidature.error.commentaireObligatoire', timeout: this.alertCommentaireObligatoireTimeout}, []);
            this.onClickOnStep(this.constants.AVIS);
        } else if(this.candidatureFormation !== undefined && this.candidatureFormation !== null
            && this.candidatureFormation.avis === this.constants.AWAITING
            && this.candidatureFormation.avisRang !== undefined
            && this.candidatureFormation.avisRang !== null
            && this.candidatureFormation.avisRang <= 0
        ) {
            // Si rang négatif pour l'avis liste complémentaire, on ne peut pas sauvegarder
            this.alertService.closeAlert(this.commentaireObligatoireAlerteId);
            this.alertService.addAlert({id: this.commentaireObligatoireAlerteId, type: 'danger',
                msg: 'cadensApp.candidature.avisRangDoitEtrePositif', timeout: this.alertCommentaireObligatoireTimeout}, []);
            this.onClickOnStep(this.constants.AVIS);
        } else if (this.isEditable && this.traitementEnabled > 0) {
            // Enregistrement fait par le Gestionnaire
            this.alertService.closeAlert(this.commentaireObligatoireAlerteId);
            this.confirmationService.confirm({
                message: this.translateService.instant('cadensApp.candidature.confirmSave.message'),
                header: this.translateService.instant('cadensApp.candidature.confirmSave.title'),
                icon: 'fa fa-check-circle-o',
                accept: () => {
                    if (Principal.isAnyAuthorityInListe(['ROLE_SYSTEM', 'ROLE_ADMIN', 'ROLE_REFERENT', 'ROLE_GEST'], this.candidatureUser.authorities)) {
                        let updates = [this.concoursService.update(this.concours)];
                        if (this.courses != null && this.courses.length > 0) {
                            updates.push(this.cursusService.update(this.courses));
                        }
                        if (this.candidatureFormation.categorieFormationId != null && this.candidatureFormation.formationId != null) {
                            updates.push(this.reponseService.update(this.questions));
                        }
                        if (this.referents != null && this.referents.length > 0) {
                            this.referents.forEach(ref => updates.push(this.referentService.update(ref, null)));
                        }
                        if (this.preavisModifEnabled && this.candidatureFormation.listePreavis != null && this.candidatureFormation.listePreavis.length > 0) {
                            updates.push(this.preavisService.update(this.candidatureFormation.listePreavis));
                        }
                        if (this.listeCours != null && this.listeCours.length > 0) {
                            this.listeCours.forEach(cours => cours.candidatureFormationId = this.candidatureFormation.id);
                            updates.push(this.coursService.update(this.listeCours));
                        }

                        if (updates.length > 0) {
                            this.isSaving = true;
                            Observable.forkJoin(updates).subscribe(() => {
                                this.updateCandidature(false, false, verifier, null);
                            }, (res: Response) => {
                                this.isSaving = false;
                                this.onError(res);
                            });
                        } else {
                            this.onErrorMessage('cadensApp.candidature.error.saveNonFait');
                        }
                    }
                }
            });
        } else {
            let updates = [];
            let updateStatus = false;
            if (Principal.isAnyAuthorityInListe(['ROLE_SYSTEM', 'ROLE_ADMIN', 'ROLE_GEST', 'ROLE_REFERENT', 'ROLE_DELEGATE'], this.candidatureUser.authorities)) {
                updates.push(this.candidatureFormationService.updateCandidaturesStatus([this.candidatureFormation], null));
                updateStatus = true;
                if (this.preavisModifEnabled && this.candidatureFormation.listePreavis != null && this.candidatureFormation.listePreavis.length > 0) {
                    updates.push(this.preavisService.update(this.candidatureFormation.listePreavis));
                }
            }
            if (updates.length > 0) {
                this.isSaving = true;
                Observable.forkJoin(updates).subscribe(() => {
                    this.isSaving = false;
                    if (updateStatus == true) {
                        this.backToListe(true);
                    } else {
                        this.load(this.candidatureFormation.id);
                    }
                }, (res: Response) => {
                    this.isSaving = false;
                    this.onError(res);
                });
            } else {
                this.onErrorMessage('cadensApp.candidature.error.saveNonFait');
                this.load(this.candidatureFormation.id);
            }
        }
    }

    verifierCandidature(): void {
        // Si pas de motif pour avis défavorable, on affiche une erreur
        if(this.candidatureFormation !== undefined && this.candidatureFormation !== null
            && this.candidatureFormation.avis === this.constants.NOTFAVORABLE
            && (this.candidatureFormation.commentaire === undefined  || this.candidatureFormation.commentaire === null)) {
            this.alertService.closeAlert(this.commentaireObligatoireAlerteId);
            this.alertService.addAlert({id: this.commentaireObligatoireAlerteId, type: 'danger',
                msg: 'cadensApp.candidature.error.commentaireObligatoire', timeout: this.alertCommentaireObligatoireTimeout}, []);
            this.onClickOnStep(this.constants.AVIS);
        } else {
            this.alertService.closeAlert(this.commentaireObligatoireAlerteId);
            this.candidatureFormationService.verifierCandidature(this.candidatureFormation.id, false).subscribe((verif: EntityVerification) => {
                    if (verif.verificationOk) {
                        this.alertService.success('cadensApp.candidature.verificationOk', null, null);
                    } else {
                        JhiAlertComponent.onErrorMessage(this.alertService, JhiAlertComponent.construitCleMessage(verif.message, verif.entityName, verif.applicationName), null);
                    }
                },
                (res: Response) => {
                    this.onError(res);
                });
        }
    }

    onError(response: Response) {
        this.isSaving = false;
        JhiAlertComponent.onError(this.alertService, response);
    }

    onErrorMessage(message: any, params?: any) {
        this.isSaving = false;
        JhiAlertComponent.onErrorMessage(this.alertService, message, params);
    }

    /** User clicks directly from UI on another step **/
    onClickOnStep(step: string) {
        if (this.currentPage === CONSTANTS.ALL) {
            let pageScrollInstance: PageScrollInstance = PageScrollInstance.simpleInstance(this.document, '#' + step);
            this.pageScrollService.start(pageScrollInstance);
        } else if (!this.isEditable || this.candidatureFormation.pageEdition === CONSTANTS.PIECES ||
            (this.candidatureFormation.pageEdition === CONSTANTS.SCOLARITE &&
                (step === CONSTANTS.CIVILITE || step === CONSTANTS.SCOLARITE)) ||
            (this.candidatureFormation.pageEdition === CONSTANTS.FORMATION &&
                (step === CONSTANTS.CIVILITE || step === CONSTANTS.SCOLARITE || step === CONSTANTS.FORMATION))) {
            this.goToStep(step);
        }
    }

    goToStep(step: string) {
        this.isSaving = false;
        this.candidatureFormation.pageEdition = step;
        this.currentPage = step;
    }

    gestionDroits(userId: Number, dateLimiteAvis: number, authoritiesListe ?: String[]) {
        this.preavisModifEnabled = false;
        this.preavisVisuAllEnabled = false;
        //le role utilisateur prend le pas sur tout les autres roles
        if (Principal.isAuthorityInListe('ROLE_USER', authoritiesListe)) {
            if (this.candidatureFormation.userId !== userId) {
                // Empêcher l'accès à la candidature d'un autre
                this.alertService.error('error.rights', null, null);
                this.router.navigate(['/espaceCandidat']);
            }
            if (this.candidatureFormation.dateValidation == null) {
                this.isEditable = true;
            } else {
                this.goToStep(CONSTANTS.CIVILITE);
            }
        } else {
            //le gestionnaire peut en général éditer les informations de la candidature
            if (Principal.isAuthorityInListe('ROLE_GEST', authoritiesListe)) {
                this.isEditable = true;
                if (this.candidatureFormation.statut === CONSTANTS.FINISHED ||
                    this.candidatureFormation.statut === CONSTANTS.CONFIRMED) {
                    this.avisEnabled = 2;
                    this.traitementEnabled = 2;
                    this.preavisVisuAllEnabled = true;
                    this.preavisModifEnabled = true;
                } else {
                    this.preavisVisuAllEnabled = true;
                    this.avisEnabled = 1;
                    this.traitementEnabled = 1;
                }
                this.loadOtherCandidatures();
            } else {
                //les systems et admins peuvent en général visualiser les informations de la candidature
                if (Principal.isAnyAuthorityInListe(['ROLE_SYSTEM', 'ROLE_ADMIN'], authoritiesListe)) {
                    this.preavisVisuAllEnabled = true;
                    this.avisEnabled = 1;
                    this.traitementEnabled = 1;
                }
                //le responsable de formation peut editer les préavis des autres et avis
                //remarque : le fait qu'il soit responsable de cette formation n'est pas vérifié ici
                if (Principal.isAuthorityInListe('ROLE_REFERENT', authoritiesListe)) {
                    this.avisEnabled = 1;
                    if (this.candidatureFormation.statut === CONSTANTS.FINISHED) {
                        if (this.candidatureFormation.avis == null || dateLimiteAvis == null) {
                            this.preavisVisuAllEnabled = true;
                            this.preavisModifEnabled = true;
                            this.avisEnabled = 2;
                        } else {
                            this.preavisVisuAllEnabled = true;
                            if (dateLimiteAvis >= Date.now()) {
                                this.preavisModifEnabled = true;
                                this.avisEnabled = 2;
                            }
                        }
                    }
                }
                //l'enseignant lecteur peut editer son préavis uniquement pour les candidatures sur sa formation
                //remarque : le fait qu'il soit lecteur sur la formation n'est pas vérifié ici
                if (Principal.isAuthorityInListe('ROLE_DELEGATE', authoritiesListe)) {
                    if (this.candidatureFormation.statut === CONSTANTS.FINISHED) {
                        if (dateLimiteAvis == null) {
                            this.preavisModifEnabled = true;
                        } else {
                            if (dateLimiteAvis >= Date.now()) {
                                this.preavisModifEnabled = true;
                            }
                        }
                    }
                }

            }
            this.candidatureFormation.pageEdition = CONSTANTS.CIVILITE;
            this.currentPage = CONSTANTS.ALL;
        }
    }

    // Changer de page dans la candidature

    loadOtherCandidatures() {
        // load other candis transmises afficher ordre
        this.candidatureFormationService.query({userId: this.candidatureFormation.userId}).subscribe(
            (res: Response) => {
                this.otherCandidatures = res.json();
                this.otherCandidatures = this.otherCandidatures.filter(candi =>
                    candi.id !== this.candidatureFormation.id && candi.dateSuppression == null);
            },
            (res: Response) => {
                this.onError(res);
            });
    }

    isLastStep(): boolean {
        return (this.currentPage === CONSTANTS.PIECES
            || (this.currentPage === CONSTANTS.FORMATION && this.candidatureFormation.reinscription));

    }

    //Renvoie vrai si la candidature est echange international
    public isCandidatureEchange() {
        return CandidatureFormationService.isCandidatureEchange(this.candidatureFormation);
    }

    exportPdf() {
        this.isSaving = true;
        this.candidatureFormationService.generatePDF(this.candidatureFormation.id, this.isUser, this.candidatureFormationService.exportPdfNormal).subscribe((res) => {
                this.isSaving = false;
                ExportService.download(res, 'Candidature_' + this.candidatureFormation.id + '.pdf');
            },
            (error => {
                this.isSaving = false;
                this.onErrorMessage({message: 'cadensApp.candidature.messages.error.genererExportPdf'});
            })
        );
    }

    auditClick() {
        this.router.navigateByUrl('/entity-audit-event/candidatureFormation/' + this.candidatureFormation.id);
    }

    historiqueClick() {
        this.router.navigateByUrl('/historique/candidatureFormation/' + this.candidatureFormation.id);
    }

    //Generation du pdf contrat de service
    genererContratEtudeInternational() {

        //vérification des référents
        if (this.isCandidatureEchange()) {
            if (!this.referentsEchangeCorrects()) {
                return this.onErrorMessage({message: 'cadensApp.candidature.messages.error.referentobligatoire'});
            } else {
                this.saveForLater();
                this.candidatureFormationService.genererContratEtudeInternational(this.candidatureFormation.id).subscribe((res) => {
                        ExportService.download(res, 'StudyContract_' + this.candidatureFormation.id + '.pdf');
                    },
                    (error => {
                        this.onErrorMessage({message: 'cadensApp.candidature.messages.error.generationContratEtude'});
                    }))
            }
        }
    }

//Generation du document suivants status acceptation, refus, attente
    genererLettreAdmission(candiId: number, pourReponseCode: string, sortieListeComplementaire: Boolean) {
        let lc: String = '_';
        if (sortieListeComplementaire == true) {
            lc = 'lc';
        }
        let fileName: String = 'reponseENS' + lc + candiId + '.pdf';
        this.isSaving = true;
        this.candidatureFormationService.genererLettreAdmission(candiId, pourReponseCode, sortieListeComplementaire).subscribe((res) => {
                this.isSaving = false;
                ExportService.download(res, fileName);
            },
            (error => {
                this.onErrorMessage({message: 'cadensApp.candidature.messages.error.genererLettreAdmission'});
            }))
    }

    @HostListener('window:scroll', [])
    onWindowScroll() {
        let scroll = this.document.body.scrollTop;
        let scrollBottom = this.document.body.scrollHeight - this.document.body.clientHeight - 50;
        this.navIsFixed = scroll < scrollBottom;
    }

    getTransmitTitle(forceTransmit: boolean, defaultTitle: string): string {
        let commissionLibelle = "";
        let commission = null;
        let title = undefined;
        if (this.isCurrentAccountNotUser == true) {
            if (this.commissionCouranteCandidature == null) {
                if (forceTransmit == false) {
                    commission = this.commissionOuvertePourCandidature;
                } else {
                    commission = this.commissionFermePourCandidature;
                }
                if (commission != null) {
                    title = this.translateService.instant('entity.action.seraTransmisSurCommission', {'commission': commission.libelle});
                } else {
                    title = this.translateService.instant('entity.action.seraTransmisSurAucuneCommission');
                }
            } else {
                title = this.translateService.instant('entity.action.estTransmisSurCommission', {'commission': this.commissionCouranteCandidature.libelle});
            }
        } else {
            title = this.translateService.instant(defaultTitle);
        }
        return title;
    }

    getVerifierTitle(defaultTitle: string): string {
        return this.translateService.instant(defaultTitle);
    }

    onFormationsDisponiblesChange($event: boolean) {
        this.desCategoriesFormationDisponibles = $event;
    }

    private savePreavis(listePreavis: Preavis[]) {
        if (this.preavisModifEnabled && listePreavis != null && listePreavis.length > 0) {
            this.preavisService.update(listePreavis).subscribe((listePreavisUpdated: any) => {
                this.candidatureFormation.listePreavis = Preavis.buildListePreavis(
                    this.currentAccount.id,
                    this.preavisVisuAllEnabled,
                    this.preavisModifEnabled,
                    this.candidatureFormation.id,
                    listePreavisUpdated.json(),
                    this.candidatureFormation.formation.lecteurs,
                    this.candidatureFormation.formation.users);

            }, (res: Response) => {
                this.onError(res);
            });
        }
    }

    private valideFormation(fullValidation: boolean) {
        let messageText = null;
        let messageParam = null;
        if (this.candidatureFormation.categorieFormationId == null || this.candidatureFormation.formationId == null) {
            messageText = 'cadensApp.candidature.messages.error.formationobligatoire';
        } else if (fullValidation) {
            if (this.questions != null) {
                let nbQuestion = 0;
                this.questions.forEach(question => {
                    if (question.obligatoire == true &&
                        (
                            question.reponseComplement == null ||
                            (question.reponseComplement.localeCompare(CasParticulierEI.EI_QUESTION_COURS_CODE) != 0 &&
                                question.reponseComplement.localeCompare(CasParticulierEI.EI_QUESTION_COURS_ECTS) != 0 &&
                                question.reponseComplement.localeCompare(CasParticulierEI.EI_QUESTION_COURS_LIBELLE) != 0
                            )
                        )
                    ) {
                        if (question.typeReponse !== CONSTANTS.NONE && (question.reponse == null || question.reponse.toString().length == 0)) {
                            messageParam = {'question': (this.currentLang === 'fr' ? question.libelle : question.libelleEn).replace(/<(.|\n)*?>/g, '')};
                            messageText = 'cadensApp.candidature.messages.error.reponse.reponseManquante';
                        }
                        if (question.typeReponse == 'CHECKBOX' && (question.reponse == null || question.reponse.toString().length == 0 || question.reponse.toString() == 'false')) {
                            messageParam = {'question': (this.currentLang === 'fr' ? question.libelle : question.libelleEn).replace(/<(.|\n)*?>/g, '')};
                            messageText = 'cadensApp.candidature.messages.error.reponse.cocheObligatoire';
                        }
                    }
                });
            }
            if (this.candidatureFormation.formationId == this.constants.ECHANGE_INTERNATIONAL_ID) {
                if (this.listeCours == null || this.listeCours.length == 0) {
                    messageText = 'cadensApp.candidature.messages.error.cours.aucun';
                } else if (this.coursService.isCoursExistant(this.listeCours)) {
                    messageText = 'cadensApp.candidature.messages.error.cours.existant';
                } else if (this.coursService.isCoursEmpty(this.listeCours)) {
                    messageText = 'cadensApp.candidature.messages.error.cours.vide';
                } else if (this.coursService.isCoursDuplique(this.listeCours)) {
                    messageText = 'cadensApp.candidature.messages.error.cours.duplique';
                }
            }
        }
        return {messageText: messageText, messageParam: messageParam};
    }

    private referentsEchangeCorrects() {
        let checkOk = true;
        let countOfReferentExchange: number = this.referents.filter(referent => referent.typeReferent == CONSTANTS.CONTACT_PEDAGO || referent.typeReferent == CONSTANTS.CONTACT_ADMIN).length;
        if (countOfReferentExchange >= 2) {
            if (this.referents.filter(referent =>
                referent.email == null || referent.email.length == 0 ||
                referent.position == null || referent.position.length == 0 ||
                referent.nom == null || referent.nom.length == 0 ||
                referent.prenom == null || referent.prenom.length == 0
            ).length > 0) {
                checkOk = false
            }
        } else {
            checkOk = false
        }
        return checkOk;
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/candidature/candidature-detail.component.ts